// 本地环境配置
module.exports = {
  title: 'MG Thailand',
  baseUrl: 'https://sns-ttpp.mgthai.com',
  // 项目地址
  baseApi: 'https://sns-ttpp.mgthai.com',
  // 本地api请求地址,注意：如果你使用了代理，请设置成'/'，如果想使用pp环境https://sns-ttpp.mgthai.com
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static'
};